import { dfpEnv } from './dfp-env';
export const queueAdvert = (advert) => {
    dfpEnv.advertsToLoad.push(advert);
};
